import { accept } from "./index.js";
/**
 * Defines the `<repo-provider>` custom element.
 *
 * It carries the realm-local repo on its `.repo` property and acts as the
 * root-level fallback answerer for `repo:handle-descriptor`. Sitting above every
 * `<patchwork-view>`, it resolves a requested url to itself (no clone) so any
 * view rendered outside a remapper (e.g. a draft overlay) still resolves and
 * the overlay shim's `find` never hangs. A nearer remapper answers
 * `{ url, cloneUrl? }` and `stopPropagation()`s first, so this only fires when
 * nothing else claims the subscription.
 */
export function registerRepoProviderElement(repo, name = "repo-provider") {
    if (customElements.get(name))
        return;
    customElements.define(name, class extends HTMLElement {
        repo = repo;
        constructor() {
            super();
            this.addEventListener("patchwork:subscribe", (event) => {
                if (event.detail.selector.type !== "repo:handle-descriptor")
                    return;
                const url = event.detail?.selector?.url;
                if (!url)
                    return;
                accept(event, (respond) => {
                    respond({ url });
                });
            });
        }
        connectedCallback() {
            if (!this.style.display)
                this.style.display = "contents";
        }
    });
}
